// components
import { Typography } from '@centria-ui-atoms/typography'

// prime components
import { InputNumber as PrInputNumber } from 'primereact/inputnumber'

// styles
import classes from './styles.module.scss'

// types
import type { InputsEnum, variantsEnum } from '@centria-ui/commons/enums'
import type { InputNumberProps } from 'primereact/inputnumber'
import type { FC } from 'react'

export interface InputProps extends InputNumberProps {
  label?: string
  inputVariant?: keyof typeof InputsEnum
  inputColor?: typeof variantsEnum.light | typeof variantsEnum.white
}

export const InputNumber: FC<InputProps> = ({
  label,
  className = '',
  inputColor = 'light',
  inputVariant = 'block',
  ...props
}) => (
  <div className='w-100'>
    {label && (
      <Typography
        Tag='label'
        fontSize='small'
        className='mb-1'
        htmlFor={props.id}>
        {label}
      </Typography>
    )}
    <PrInputNumber
      {...props}
      incrementButtonClassName={classes.button}
      decrementButtonClassName={classes.button}
      className={`${className} ${classes.number} ${classes.input}`}
      inputClassName={`${classes[`input_${inputColor}`]} ${
        classes[`input_${inputVariant}`]
      }`}
    />
  </div>
)
